module.exports = __webpack_public_path__ + "static/media/settings.0cefad92.svg";